/**
 * @generated SignedSource<<ecd9b539f29da475f11c20cce4159570>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentTitleSectionFragment$data = {
  readonly id: string;
  readonly name: string | null;
  readonly " $fragmentType": "ContentTitleSectionFragment";
};
export type ContentTitleSectionFragment$key = {
  readonly " $data"?: ContentTitleSectionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentTitleSectionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentTitleSectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": null
};

(node as any).hash = "fd807dc523dbae85f27ffd956fd17684";

export default node;
